import * as account from './account';
import * as groupPermission from './groupPermission';
import * as tokens from './tokens';
import * as agents from './agents';
import * as plans from './plans';

export default ({
  account,
  groupPermission,
  tokens,
  agents,
  plans
});